import { render, staticRenderFns } from "./replace.vue?vue&type=template&id=2d00bcc4&scoped=true"
import script from "./replace.vue?vue&type=script&lang=js"
export * from "./replace.vue?vue&type=script&lang=js"
import style0 from "./replace.vue?vue&type=style&index=0&id=2d00bcc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00bcc4",
  null
  
)

export default component.exports